<div class="modal-body">
  <div class="row">
    <div class="col-6" *ngFor="let itm of currentFields">
      <div class="form-group">
        <label for="exampleInputEmail1">{{itm.variable}}</label>
        <input type="text" class="form-control" id="itm.variable" name="itm.variable" [(ngModel)]="itm.value" />
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col text-right">
      <button (click)="onViewMode('edit')" class="btn btn-sm btn-secondary btn-round btn-icon">
        <i class="nc-icon nc-minimal-left"></i>
      </button>
      <button (click)="onPreview()" class="btn btn-sm btn-primary btn-round btn-icon">
        <i class="nc-icon nc-glasses-2"></i>
      </button>
    </div>
  </div>
  <hr/>
  <div [innerHtml]="currentTemplate"></div>
</div>

